export default __webpack_public_path__ + "static/media/servico6.cd9e6912.jpg";